<template>
    <div class="p-0 pt-2">
        <input type="hidden" name="_token" :value="csrf" />
        <input type="hidden" name="customer" :value="customer" />
        <input type="hidden" name="order" :value="currentOrder ? currentOrder.id : 0" />
        <input type="hidden" name="promoCodes" :value="JSON.stringify(c_promoCodes)" />
        <input
            type="hidden"
            name="promoCodesImpact"
            :value="
                c_cartItems
                    ? JSON.stringify(
                          Object.values(c_cartItems)
                              .map((x) => x.codePromo)
                              .filter((x) => x.length)
                      )
                    : null
            "
        />
        <input type="hidden" name="totalDiscount" :value="totalDiscount" />

        <!-- <input
            v-if="accompte && this.promoCode"
            type="hidden"
            name="total"
            :value="
                parseFloat(
                    cartTotal -
                        accompte -
                        this.promoCode.discount_amount * (((this.cartTotal - this.accompte) * 100) / this.cartTotal / 100)
                ).toFixed(2)
            "
        />
        <input
            v-if="accompte && !this.promoCode"
            type="hidden"
            name="total"
            :value="parseFloat(cartTotal - accompte).toFixed(2)"
        />

        <input
            v-if="rest && this.promoCode"
            type="hidden"
            name="total"
            :value="
                parseFloat(
                    totalWRest -
                        this.promoCode.discount_amount * (((this.cartTotal - this.rest) * 100) / this.cartTotal / 100) +
                        this.promoCode.discount_amount
                ).toFixed(2)
            "Moyen de paiement
        />
        <input v-if="rest && !this.promoCode" type="hidden" name="total" :value="parseFloat(totalWRest).toFixed(2)" />

        <input
            v-if="!rest && !accompte && this.promoCode"
            type="hidden"
            name="total"
            :value="
                parseFloat(cartTotal - this.promoCode.discount_amount * ((this.cartTotal * 100) / this.cartTotal / 100)).toFixed(
                    2
                )
            "
        />

        <input
            v-if="!rest && !accompte && !this.promoCode"
            type="hidden"
            name="total"
            :value="parseFloat(cartTotal).toFixed(2)"
        /> -->

        <!-- <input v-if="this.promoCode" type="hidden" name="promo" :value="JSON.stringify(selectCode)" /> -->
        <input v-if="accompte" type="hidden" name="status" :value="'account'" />
        <input v-if="rest" type="hidden" name="status" :value="'rest'" />
        <input v-if="!rest && !accompte" type="hidden" name="status" :value="'total'" />

        <div class="row my-3 mb-0 m-sm-0">
            <h3
                class="poppinsSemiBold ppv2-text-base mb-0 mt-2 pt-2 d-flex align-items-center cursor-pointer hover:ppv2-opacity-80"
                style="color: #021832"
                @click="toggleContentVisibility()"
            >
                {{ $t('checkout.payment.advantages') }}
                <svg
                    id="toggleButton"
                    class="ms-3 ppv2-transition-transform ppv2-duration-300"
                    v-bind:class="{ 'ppv2-rotate-180': show }"
                    width="18"
                    height="18"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M15 12.5L10 7.5L5 12.5"
                        stroke="currentColor"
                        stroke-width="2.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </h3>
            <div v-if="show" id="avantage-section" class="row pe-0 align-items-baseline mt-1">
                <p class="text-danger mb-0" v-if="c_promoCodes.length >= 1">
                    <small>{{ $t('checkout.payment.promo_code_limit') }}</small>
                </p>

                <div class="col-lg-12 col-sm-12 d-flex justify-content-between align-items-baseline gap-3 pe-0 py-0 bnd-resp">
                    <div class="ps-0 w-100">
                        <div class="d-flex flex-column w-100">
                            <select
                                @change="selectReductionCode($event)"
                                class="form-select ppv2-rounded-xl ppv2-border-[#E2E8F0] ppv2-h-[42px] ppv2-text-sm poppinsRegular"
                                name="promo_code"
                                id="promo-code-select-reduction"
                            >
                                <option value="" disabled selected>{{ $t('checkout.payment.add_promo_code') }}</option>
                                <option
                                    v-for="promoCode in promoCodesData.forBackOfficeOnly"
                                    :key="promoCode.id"
                                    :value="promoCode.code"
                                >
                                    {{ promoCode.title }}
                                    <span> | </span>
                                    {{ promoCode.discount_amount }}
                                    {{ promoCode.discount_type == 'fixed' ? $symbolCurrency : '%' }}

                                    {{ promoCode.is_global ? $t('checkout.payment.global_discount') : '' }}
                                </option>
                            </select>
                            <div v-if="currentPromoCode" class="mb-1">
                                <span v-if="infoReductionCode" class="ppv2-text-info ppv2-text-xs poppinsMedium">{{
                                    infoReductionCode
                                }}</span>
                                <span v-if="errorReductionCode" class="ppv2-text-danger ppv2-text-xs poppinsMedium">{{
                                    errorReductionCode
                                }}</span>
                            </div>
                        </div>
                    </div>
                    <button
                        type="button"
                        :class="[
                            errorReductionCode ? 'ppv2-bg-red-500 ppv2-text-white' : 'ppv2-bg-[#021832] ppv2-text-white',
                            successReductionApplied ? 'ppv2-bg-green-500' : '',
                        ]"
                        class="ppv2-px-6 ppv2-h-[42px] ppv2-rounded-xl ppv2-text-sm poppinsSemiBold ppv2-transition-all hover:ppv2-opacity-90 disabled:ppv2-opacity-50"
                        @click="applyPromoCode('reduction')"
                        :disabled="
                            errorReductionCode ||
                            c_promoCodes.length >= 1 ||
                            !(canModifyOrder === true || canModifyOrder === 'true')
                        "
                    >
                        <span v-if="!successReductionApplied">{{ $t('checkout.payment.apply') }}</span>
                        <span v-else>{{ $t('checkout.payment.applied') }}</span>
                    </button>
                </div>

                <div class="col-lg-12 col-sm-12 d-flex justify-content-between align-items-baseline gap-3 pe-0 py-0 bnd-resp">
                    <div class="ps-0 w-100">
                        <div class="d-flex flex-column w-100">
                            <select
                                @change="selectPromoCode($event)"
                                class="form-select ppv2-rounded-xl ppv2-border-[#E2E8F0] ppv2-h-[42px] ppv2-text-sm poppinsRegular"
                                name="promo_code"
                                id="promo-code-select-others"
                            >
                                <option value="" disabled selected>{{ $t('checkout.payment.add_another_promo_code') }}</option>
                                <option v-for="promoCode in promoCodesData.others" :key="promoCode.id" :value="promoCode.code">
                                    {{ promoCode.title }}
                                    <span> | </span>
                                    {{ promoCode.discount_amount }}
                                    {{ promoCode.discount_type == 'fixed' ? $symbolCurrency : '%' }}

                                    {{ promoCode.is_global ? $t('checkout.payment.global_discount') : '' }}
                                </option>
                            </select>
                            <div v-if="currentPromoCode" class="mb-1">
                                <span v-if="infoPromoCode" class="ppv2-text-info ppv2-text-xs poppinsMedium">{{
                                    infoPromoCode
                                }}</span>
                                <span v-if="errorPromoCode" class="ppv2-text-danger ppv2-text-xs poppinsMedium">{{
                                    errorPromoCode
                                }}</span>
                            </div>
                        </div>
                    </div>

                    <button
                        type="button"
                        :class="[
                            errorPromoCode ? 'ppv2-bg-red-500 ppv2-text-white' : 'ppv2-bg-[#021832] ppv2-text-white',
                            successPromoApplied ? 'ppv2-bg-green-500' : '',
                        ]"
                        class="ppv2-px-6 ppv2-h-[42px] ppv2-rounded-xl ppv2-text-sm poppinsSemiBold ppv2-transition-all hover:ppv2-opacity-90 disabled:ppv2-opacity-50"
                        @click="applyPromoCode('promo')"
                        :disabled="
                            errorPromoCode || c_promoCodes.length >= 1 || !(canModifyOrder === true || canModifyOrder === 'true')
                        "
                    >
                        <span v-if="!successPromoApplied">{{ $t('checkout.payment.apply') }}</span>
                        <span v-else>{{ $t('checkout.payment.applied') }}</span>
                    </button>
                </div>
            </div>

            <div class="d-flex justify-content-between mt-3 flex-wrap align-items-center ppv2-mb-4">
                <h3 class="poppinsSemiBold ppv2-text-base mb-0" style="color: #021832">{{ $t('checkout.payment.title') }}</h3>
                <div class="bg-purple ppv2-px-6 ppv2-py-1 ppv2-rounded-full ppv2-shadow-lg ppv2-shadow-purple-200/50 ppv2-mb-2">
                    <span class="text-white poppinsMedium" :style="{ fontSize: normalizeFontSize(14) }"
                        >{{ $t('checkout.payment.remain_to_pay') }} </span
                    ><span class="text-white poppinsBold ms-2" :style="{ fontSize: normalizeFontSize(18) }">
                        {{ c_remainPrice && c_remainPrice.includes('-0.00') ? '0.00' : c_remainPrice }}
                        {{ $symbolCurrency }}
                    </span>
                </div>
            </div>

            <div class="row ppv2--mx-2 ppv2-items-stretch">
                <div v-for="(method, index) in c_payments" :key="index" class="col-lg-4 col-md-4 col-sm-6 col-xs-12 !ppv2-p-1">
                    <PaymentCard :method="method" :remainPrice="c_remainPrice">
                        <template #checkbox class="moyens">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                value=""
                                :id="'checkbox_' + method.name"
                                :name="'checkbox_' + method.name"
                                @change="selectPaymentMethod($event, method)"
                                :disabled="
                                    !(canCreateOrder === true || canCreateOrder === 'true') &&
                                    !(canModifyOrder === true || canModifyOrder === 'true')
                                "
                                style=""
                            />
                        </template>
                        <template #input>
                            <input
                                type="number"
                                class="form-control form-control-sm disabled"
                                :name="'payments[' + method.name + ']'"
                                :id="'payments[' + method.name + ']'"
                                @keyup="keyupPaymentMethod($event, method)"
                                min="1"
                                :max="c_remainPrice"
                                :ref="'input_' + method.name"
                                v-model="method.value"
                                readonly
                                v-show="!paymentMethodWithoutInput.includes(method.name.toLowerCase())"
                            />
                        </template>
                    </PaymentCard>
                </div>
            </div>

            <PaymentStripe
                :userId="userId"
                :orderId="orderId"
                :stripeKey="stripeKey"
                :maxAmount="c_remainPrice"
                v-if="show_stripe_block === true"
            ></PaymentStripe>
            <PaymentKlarna
                :userId="userId"
                :orderId="orderId"
                :currentOrder="currentOrder"
                v-if="show_klarna_block === true"
            ></PaymentKlarna>
            <voucher-tab
                v-if="show_voucher_block"
                :current_name="$t('checkout.categories.vouchers')"
                voucher_type="voucher"
            ></voucher-tab>
            <voucher-tab
                v-if="show_billet_block"
                :current_name="$t('checkout.categories.undated_ticket')"
                voucher_type="isUndatedTicket"
            ></voucher-tab>
            <serie-treatment-tab v-if="show_package_block"></serie-treatment-tab>
            <serie-tab v-if="show_serie_block"></serie-tab>

            <!-- <contributor-tab></contributor-tab> -->
        </div>
    </div>
</template>

<script>
import { get, sync } from 'vuex-pathify'
import PaymentCard from './PaymentCard.vue'
import InitManager from '../../Checkout_BO/CheckoutOverlay/_core/InitManager'
import ApiManager from '../../Checkout_BO/CheckoutOverlay/_core/ApiManager'
import PaymentStripe from './PaymentStripe.vue'
import PaymentKlarna from './PaymentKlarna.vue'
import normalizeSize from '../../../utils/normalizeSize'
import normalizeFontSize from '../../../utils/normalizeFontSize'

export default {
    props: [
        // Customer
        // Object type : USER
        'customer',

        // Promo codes
        'promoCodes',
        'promoCode',

        // Payment
        'paymentMethods',
        'usedFidelityPoints',

        // Numbers and totals
        'cartTotal',
        'rest',
        'accompte',
        'currentOrder',
        'promotions',
        'userId',
        'orderId',
        'customerWalletBalance',
        'stripeKey',
        'canCreateOrder',
        'canModifyOrder',
    ],
    data: () => ({
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        currentPromoCode: null,
        codeApplicable: false,
        totalDiscount: 0,
        errorPromoCode: null,
        infoPromoCode: null,
        successPromoApplied: false,
        successReductionApplied: false,
        errorReductionCode: null,
        infoReductionCode: null,
        copyCards: null,
        show: false,
        show_stripe_block: false,
        show_klarna_block: false,
        show_package_block: false,
        show_serie_block: false,
        show_voucher_block: false,
        show_billet_block: false,
        paymentMethodWithoutInput: ['stripe', 'klarna', 'cure', 'serie', 'forfait', 'bon cadeau', 'billet non daté'],
        promoCodesData: {
            forBackOfficeOnly: [],
            others: [],
        },
    }),
    computed: {
        ...get('overlay@data', {
            c_remainPrice: 'remainPrice',
            c_tmpPromoCodes: 'tmpPromoCodes',
        }),
        ...sync('overlay@data', {
            c_cartItems: 'cartItems',
            c_payments: 'payments',
            c_promoCodes: 'promoCodes',
        }),
        /**
         * Total brut du panier : somme de (prix × quantité) pour chaque article,
         * sans tenir compte des paiements déjà saisis ni des remises globales.
         */
        orderTotal() {
            if (!this.c_cartItems) return 0
            return Object.values(this.c_cartItems).reduce((total, item) => {
                const price = parseFloat(item._oldPrice ?? item.price) || 0
                const qty = parseInt(item.qty) || 1
                return total + price * qty
            }, 0)
        },
    },
    components: {
        PaymentCard,
        PaymentStripe,
        PaymentKlarna,
    },
    watch: {
        c_tmpPromoCodes: {
            handler(val, prev) {
                if (!val || !val.length || !prev || prev.length) return

                val.forEach((t) => {
                    this.selectPromoCode({ target: { value: t.code } }, true)
                        .then(() => this.applyPromoCode('promo'))
                        .then(() => {
                            // console.log(this.c_promoCodes, this.promotions, this.c_cartItems);
                            this.promotions.forEach((p) => {
                                if (p.real_amount == 0) {
                                    this.c_cartItems[p.item_order_id].code.find((x) => x.id == p.promotion_id).enable = false
                                }
                            })
                        })
                })
            },
            deep: true,
        },
        c_cartItems: {
            handler(val, prev) {
                if (val && prev && Object.keys(val).length && !Object.keys(prev).length)
                    this.copyCards = JSON.parse(JSON.stringify(this.c_cartItems))
            },
            deep: true,
        },
        promoCodes: {
            handler() {
                this.classifyPromoCodes()
            },
            deep: true,
        },
    },
    methods: {
        normalizeFontSize,
        normalizeSize,
        keyupPaymentMethod(event, data) {
            if (data.name == 'Wallet' && data.value > this.customerWalletBalance) {
                data.value = this.customerWalletBalance
            }
        },
        selectPaymentMethod(event, data) {
            //  console.log('event.target.checked', event.target.checked, data.name.toLowerCase())
            //  console.log('this.c_remainPrice !== 0', this.c_remainPrice !== 0)
            //  console.log('this.c_payments.find((x) => x.value != 0', !this.c_payments.find((x) => x.value != 0))

            if (event.target.checked) {
                // this.current_name = data.display_name
                this.$refs['input_' + data.name][0].removeAttribute('readonly')
                if (!this.c_payments.find((x) => x.value != 0) || this.c_remainPrice !== 0) {
                    switch (data.name.toLowerCase()) {
                        case 'stripe':
                            this.show_stripe_block = true
                            break
                        case 'klarna':
                            this.show_klarna_block = true
                            break
                        case 'cure':
                            this.show_package_block = true
                            break
                        case 'serie':
                            this.show_serie_block = true
                            break
                        case 'bon cadeau':
                            this.show_voucher_block = true
                            break
                        case 'billet non daté':
                            this.show_billet_block = true
                            break
                        case 'Wallet':
                            data.value =
                                this.customerWalletBalance >= this.c_remainPrice ? this.c_remainPrice : this.customerWalletBalance
                            break
                        default:
                            data.value = this.c_remainPrice
                            break
                    }
                }
            } else {
                this.$refs['input_' + data.name][0].setAttribute('readonly', true)
                data.value = 0
                switch (data.name.toLowerCase()) {
                    case 'stripe':
                        this.show_stripe_block = false
                        break
                    case 'klarna':
                        this.show_klarna_block = false
                        break
                    case 'cure':
                        this.show_package_block = false
                        break
                    case 'serie':
                        this.show_serie_block = false
                        break
                    case 'bon cadeau':
                        this.show_voucher_block = false
                        break
                    case 'billet non daté':
                        this.show_billet_block = false
                        break
                }
            }
        },

        // Get baskets item who is targeted by promoCode
        async _getEligibleCards(cards, promoCode, type, type_model) {
            const res = type.includes('categories')
                ? // Check same categories
                  await this._asyncFilter(cards, async (card) => {
                      const categoryId = await ApiManager.getItemCategory(card.options.item_id, card.options.type).then(
                          (res) => res.data
                      )

                      return promoCode[type].find((p) => p.id == categoryId && card.options.type == type_model) != null
                  })
                : // Check same type
                  cards.filter((card) =>
                      promoCode[type]?.find(
                          (p) => p.id == card.options.item_id && card.options.type.toLowerCase().includes(type.slice(0, -1))
                      )
                  )
            return res
        },

        async _asyncFilter(values, func) {
            const shouldFilter = await Promise.all(values.map(func))
            return values.filter((value, index) => shouldFilter[index])
        },

        // Check validity of code promo
        _isAnInvalidCodePromo(promoCode) {
            if (promoCode.isExpired) return this.$t('checkout.payment.errors.expired')
            if (promoCode.expiration_date && moment(promoCode.expiration_date).toDate() < new Date())
                return this.$t('checkout.payment.errors.expired_since', { date: promoCode.expiration_date })
            if (promoCode.disabled) return this.$t('checkout.payment.errors.disabled')
            if (promoCode.uses != null && promoCode.uses <= 0) return this.$t('checkout.payment.errors.limit_reached')
            return null
        },

        _computeAmountCodePromo(amount, currentCode) {
            let res = 0
            if (currentCode.discount_type == 'fixed') {
                res = amount > currentCode.discount_amount ? currentCode.discount_amount : amount
            } else if (currentCode.discount_type == 'percentage') {
                res = amount * (currentCode.discount_amount / 100)
            }
            return res
        },

        // Get amount of remise of promoCode
        async _getTotalRemise(cardsObj, promoCodeTxt, alreadyApplied = false) {
            var cards = Object.keys(cardsObj).map(function (key) {
                cardsObj[key]._key = key
                return cardsObj[key]
            })
            cards = cards.filter((x) => x.canApplyPromoCode)
            if (alreadyApplied) {
                var currentCode = await ApiManager.getItemPromoCode(promoCodeTxt)
            } else {
                var currentCode = await ApiManager.getPromoCode(promoCodeTxt)
            }

            // If error back return error string
            if (!currentCode || typeof currentCode === 'string')
                return { error: currentCode || this.$t('checkout.payment.errors.internal_error') }

            // check basic errors
            if (!alreadyApplied) {
                const error = this._isAnInvalidCodePromo(currentCode)
                if (error) return { error: error, currentCode }
            }
            // [GLOBAL]
            if (currentCode.is_global) {
                // if (currentCode.discount_type == 'fixed') currentCode.linked_cart_items = cards && cards[0] ? [cards[0]] : []
                currentCode.linked_cart_items = [...cards]
                return { currentCode }
            }

            // [NOT GLOBAL]
            else {
                let ttlist = []
                // console.log(JSON.stringify(currentCode))
                if (currentCode.products && currentCode.products.length > 0)
                    ttlist = ttlist.concat(
                        await this._getEligibleCards(cards, currentCode, 'products', 'App\\Models\\Product\\Product')
                    )
                if (currentCode.prestations && currentCode.prestations.length > 0)
                    ttlist = ttlist.concat(
                        await this._getEligibleCards(cards, currentCode, 'prestations', 'App\\Models\\Prestation\\Prestation')
                    )
                if (currentCode.product_categories && currentCode.product_categories.length > 0)
                    ttlist = ttlist.concat(
                        await this._getEligibleCards(cards, currentCode, 'product_categories', 'App\\Models\\Product\\Product')
                    )
                if (currentCode.foods && currentCode.foods.length > 0)
                    ttlist = ttlist.concat(await this._getEligibleCards(cards, currentCode, 'foods', 'App\\Models\\Food\\Food'))
                if (currentCode.food_packs && currentCode.food_packs.length > 0)
                    ttlist = ttlist.concat(
                        await this._getEligibleCards(cards, currentCode, 'food_packs', 'App\\Models\\Food\\FoodPack')
                    )
                if (currentCode.foods_categories && currentCode.foods_categories.length > 0)
                    ttlist = ttlist.concat(
                        await this._getEligibleCards(cards, currentCode, 'foods_categories', 'App\\Models\\Food\\FoodCategory')
                    )
                if (currentCode.prestation_categories && currentCode.prestation_categories.length > 0)
                    ttlist = ttlist.concat(
                        await this._getEligibleCards(
                            cards,
                            currentCode,
                            'prestation_categories',
                            'App\\Models\\Prestation\\Prestation'
                        )
                    )
                if (currentCode.treatments && currentCode.treatments.length > 0)
                    ttlist = ttlist.concat(await this._getEligibleCards(cards, currentCode, 'treatments', 'App\Models\Treatment'))

                let ids = []

                ttlist = ttlist.filter((v) => {
                    if (!ids.find((id) => id === v._key)) {
                        ids.push(v._key)
                        return true
                    }
                    return false
                })

                currentCode.linked_cart_items = [...ttlist]
                return { currentCode }
            }
        },

        async selectPromoCode(event, alreadyApplied = false) {
            this.errorPromoCode = null
            this.infoPromoCode = null

            if (event.target.value !== '') {
                // Total brut du panier (prix × qté, avant paiements)
                const total = this.orderTotal
                console.log('[selectPromoCode] total =', total)

                const res = await this._getTotalRemise(this.c_cartItems, event.target.value, alreadyApplied)

                if (res.error) {
                    this.errorPromoCode = res.error
                }
                if (!res.currentCode) return

                // Vérifier montant minimum si défini sur le code promo
                if (
                    res.currentCode.min_amount != null &&
                    res.currentCode.min_amount != 0 &&
                    parseFloat(res.currentCode.min_amount) > total
                ) {
                    this.errorPromoCode = this.$t('checkout.payment.errors.min_amount', {
                        amount: parseFloat(res.currentCode.min_amount).toFixed(2),
                        symbol: window.symbolCurrency ?? '',
                    })
                    this.successPromoApplied = false
                    return
                }

                if (
                    res.currentCode.max_amount != null &&
                    res.currentCode.max_amount != 0 &&
                    parseFloat(res.currentCode.max_amount) < total
                ) {
                    this.errorPromoCode = this.$t('checkout.payment.errors.max_amount', {
                        amount: parseFloat(res.currentCode.max_amount).toFixed(2),
                        symbol: window.symbolCurrency ?? '',
                    })
                    this.successPromoApplied = false
                    return
                }

                if (this.c_promoCodes.find((x) => x.id == res.currentCode.id)) {
                    this.errorPromoCode = this.$t('checkout.payment.errors.already_used')
                    this.successPromoApplied = false
                    return
                }
                if (!this.checkIfApplyPromoCode(res.currentCode)) {
                    this.errorPromoCode = this.$t('checkout.payment.errors.not_applicable')
                    this.successPromoApplied = false
                    return
                }
                this.infoPromoCode = this.$t('checkout.payment.info.applicable')
                this.successPromoApplied = false
                this.currentPromoCode = res.currentCode
            } else {
                this.errorPromoCode = this.$t('checkout.payment.errors.not_found')
            }
            return this.currentPromoCode
        },
        async selectReductionCode(event) {
            this.errorReductionCode = null
            this.infoReductionCode = null

            const total = this.orderTotal
            console.log('[selectPromoCode] total =', total)

            //  console.log(this.c_promoCodes)
            if (event.target.value != '') {
                const res = await this._getTotalRemise(this.c_cartItems, event.target.value)
                // ici faire le test applicable ou nn
                if (res.error) {
                    this.errorReductionCode = res.error
                }
                if (!res.currentCode) return

                if (this.c_promoCodes.find((x) => x.id == res.currentCode.id)) {
                    this.errorReductionCode = this.$t('checkout.payment.errors.already_used')
                    this.successReductionApplied = false

                    return
                }
                if (
                    res.currentCode.min_amount != null &&
                    res.currentCode.min_amount != 0 &&
                    parseFloat(res.currentCode.min_amount) > total
                ) {
                    this.errorReductionCode = this.$t('checkout.payment.errors.min_amount', {
                        amount: parseFloat(res.currentCode.min_amount).toFixed(2),
                        symbol: window.symbolCurrency ?? '',
                    })
                    this.successReductionApplied = false
                    return
                }

                if (
                    res.currentCode.max_amount != null &&
                    res.currentCode.max_amount != 0 &&
                    parseFloat(res.currentCode.max_amount) < total
                ) {
                    this.errorReductionCode = this.$t('checkout.payment.errors.max_amount', {
                        amount: parseFloat(res.currentCode.max_amount).toFixed(2),
                        symbol: window.symbolCurrency ?? '',
                    })
                    this.successReductionApplied = false
                    return
                }

                if (!this.checkIfApplyPromoCode(res.currentCode)) {
                    this.errorReductionCode = this.$t('checkout.payment.errors.not_applicable')
                    this.successReductionApplied = false

                    return
                }

                this.infoReductionCode = this.$t('checkout.payment.info.applicable')
                this.successReductionApplied = false

                this.currentPromoCode = res.currentCode
            }
            return this.currentPromoCode
        },
        checkIfApplyPromoCode(promoCode) {
            let isApplied = false
            if (this.c_promoCodes.find((x) => x.id == promoCode.id)) {
                return
            }

            if (promoCode.has_voucher) {
                for (const key in this.c_cartItems) {
                    if (this.c_cartItems[key].options.type === 'App\\Models\\Voucher\\Voucher') {
                        // Init

                        isApplied = true
                    }
                }
            }
            if (promoCode.linked_cart_items) {
                promoCode.linked_cart_items.forEach((card) => {
                    for (const key in this.c_cartItems) {
                        if (this.c_cartItems[key].id === card.id) {
                            // Init
                            isApplied = true
                        }
                    }
                })
            }

            return isApplied
        },

        applyPromoCode(type) {
            if (type === 'promo') {
                this.successPromoApplied = true
            } else {
                this.successReductionApplied = true
            }
            if (!this.currentPromoCode) {
                return
            }
            if (this.c_promoCodes.find((x) => x.id == this.currentPromoCode.id)) {
                if (type === 'promo') {
                    this.successPromoApplied = false
                } else {
                    this.successReductionApplied = false
                }
                return
            }
            if (this.currentPromoCode) this.c_promoCodes.push(this.currentPromoCode)

            if (this.currentPromoCode.has_voucher) {
                for (const key in this.c_cartItems) {
                    if (this.c_cartItems[key].options.type === 'App\\Models\\Voucher\\Voucher') {
                        if (!this.c_cartItems[key]._oldPrice) this.c_cartItems[key]._oldPrice = this.c_cartItems[key].price
                        if (!this.c_cartItems[key].code) this.c_cartItems[key].code = []

                        // Push code
                        this.c_cartItems[key].code.push({
                            id: this.currentPromoCode.id,
                            title: this.currentPromoCode.title,
                            amount: `${this.currentPromoCode.discount_amount}${
                                this.currentPromoCode.discount_type == 'fixed' ? window.symbolCurrency : '%'
                            }`,
                            discount_type: this.currentPromoCode.discount_type,
                            discount_amount: this.currentPromoCode.discount_amount,
                            enable: true,

                            has_voucher: this.currentPromoCode.has_voucher,

                            global: this.currentPromoCode.is_global,
                            last: this.currentPromoCode.is_global && this.currentPromoCode.discount_type == 'fixed' ? 1 : 0,
                            code: this.currentPromoCode.code,
                        })
                        //this.c_cartItems[key].code.sort((a, b) => a.last - b.last)
                    }
                }
            }

            if (this.currentPromoCode.linked_cart_items) {
                this.currentPromoCode.linked_cart_items.forEach((card) => {
                    for (const key in this.c_cartItems) {
                        if (this.c_cartItems[key].id === card.id) {
                            // Init

                            if (!this.c_cartItems[key]._oldPrice) this.c_cartItems[key]._oldPrice = this.c_cartItems[key].price
                            if (!this.c_cartItems[key].code) this.c_cartItems[key].code = []

                            // Push code
                            this.c_cartItems[key].code.push({
                                id: this.currentPromoCode.id,
                                title: this.currentPromoCode.title,
                                amount: `${this.currentPromoCode.discount_amount}${
                                    this.currentPromoCode.discount_type == 'fixed' ? window.symbolCurrency : '%'
                                }`,
                                discount_type: this.currentPromoCode.discount_type,
                                discount_amount: this.currentPromoCode.discount_amount,
                                enable: true,

                                has_voucher: false,

                                global: this.currentPromoCode.is_global,
                                last: this.currentPromoCode.is_global && this.currentPromoCode.discount_type == 'fixed' ? 1 : 0,
                                code: this.currentPromoCode.code,
                            })
                            this.c_cartItems[key].code.sort((a, b) => a.last - b.last)
                        }
                    }
                })
            }
            //   console.log(this.successPromoApplied, this.successReductionApplied, type === 'promo', type)
            this.infoPromoCode = null
            this.errorPromoCode = null
            this.infoReductionCode = null
            this.errorReductionCode = null
        },

        async deleteCode(index) {
            this.currentPromoCode = null
            let deletePromo = this.c_promoCodes[index]
            if (deletePromo.back_office_only) {
                this.successReductionApplied = false
                this.errorReductionCode = null
                this.infoReductionCode = null
            } else {
                this.errorPromoCode = null
                this.infoPromoCode = null
                this.successPromoApplied = false
            }
            const newPromo = [...this.c_promoCodes]
            newPromo.splice(index, 1)
            this.c_promoCodes = []

            // restore
            this.c_cartItems = JSON.parse(JSON.stringify(this.copyCards))

            // re-apply promo
            for (let i = 0; i < newPromo.length; i++) {
                const p = newPromo[i]
                if (p.back_office_only) {
                    await this.selectReductionCode({ target: { value: p.code } })
                        .then(() => this.applyPromoCode('reduction'))
                        .then(() => {})
                } else {
                    await this.selectPromoCode({ target: { value: p.code } })
                        .then(() => this.applyPromoCode('promo'))
                        .then(() => {})
                }
            }
        },
        toggleContentVisibility() {
            this.show = !this.show
        },
        classifyPromoCodes() {
            this.promoCodesData.forBackOfficeOnly = this.promoCodes.filter((x) => x.back_office_only && !x.disabled)
            this.promoCodesData.others = this.promoCodes.filter((x) => !x.back_office_only && !x.disabled)
        },
    },
    async mounted() {
        this.classifyPromoCodes()
    },
}
</script>

<style scoped>
#promo-code-select {
    margin: 15px 0px;
    width: 100%;
}
select#promo-code-select {
    height: 40px;
    font-size: clamp(12px, 0.729545vw, 16px);
    padding-top: 9px;
    border-radius: 7px;
}
.btn-dark-appli {
    font-size: 16px !important;
    padding-left: 26px !important;
    padding-right: 26px !important;
    height: 38px !important;
    line-height: 24px !important;
    border-radius: 8px !important;
    font-weight: 500 !important;
}
.btn-green-appli {
    color: #fff !important;
    background: #46d5b3;
    font-size: 16px !important;
    padding-left: 29px !important;
    padding-right: 29px !important;
    height: 38px !important;
    line-height: 24px !important;
    border-radius: 8px !important;
    font-weight: 500 !important;
    border: solid 1px #46d5b3;
}
.form-control,
.form-select {
    border-radius: 8px;
    height: 40px;
    /*padding-top: 8px;*/
    font-size: clamp(12px, 0.729545vw, 16px);
}
.rest-du {
    background: #7d2dbd;
    border-radius: 4px;
    padding: 5px 12px;
    height: 32px !important;
}
.box-amount {
    font-weight: 400px;
    font-size: 12px;
    padding: 2px 17px;
    border-radius: 4px;
    background: #46d5b3;
    color: white;
}
.some-amount {
    border: solid 1px #7b8289;
    border-radius: 8px;
    padding: 4px 8px;
    width: 80%;
}
.title-some-am {
    border-bottom: solid 1px #7d2dbd;
}
#toggleButton {
    cursor: pointer;
    transition: transform 0.3s;
}
.disable-focus:focus {
    border-color: none !important;
    box-shadow: none !important;
}
</style>
